import { DateTime } from 'luxon';
import { TimeZone } from '../types';

const handleDST = (dateTime: DateTime, timeZone: TimeZone) => {
  const now = DateTime.now().setZone(timeZone.tzdbId);
  let dateTimeWithDST = dateTime;
  if (now.isInDST && !dateTime.isInDST) {
    dateTimeWithDST = dateTimeWithDST.plus({ hours: 1 });
  }

  if (!now.isInDST && dateTime.isInDST) {
    dateTimeWithDST = dateTimeWithDST.plus({ hours: -1 });
  }
  return dateTimeWithDST;
};

export default handleDST;
